import { AccredibleLocationApiService } from '@accredible-frontend-v2/services/location';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { getRadiusString } from '../../helpers/location-filter.helper';
import { SpotlightProfilesActions } from './spotlight-profiles.actions';
import { SpotlightProfilesApiService } from './spotlight-profiles.service';

@Injectable()
export class SpotlightProfilesEffects {
  private readonly _actions$ = inject(Actions);
  private readonly _spotlightProfileApi = inject(SpotlightProfilesApiService);
  private readonly _locationApi = inject(AccredibleLocationApiService);

  loadPlaceDetails$ = createEffect(() =>
    this._actions$.pipe(
      ofType(SpotlightProfilesActions.loadPlaceDetails),
      switchMap(({ directoryId, placeId, filters }) =>
        this._locationApi.getPlaceDetails(placeId).pipe(
          map(({ result }) =>
            SpotlightProfilesActions.loadPlaceDetailsSuccess({
              directoryId: directoryId,
              filters: {
                ...filters,
                lat: result.geometry.location.lat,
                lng: result.geometry.location.lng,
                custom_location_distance: getRadiusString(result, filters.custom_location_distance),
                viewport: result.geometry.viewport,
              },
            }),
          ),
          catchError((error) => of(SpotlightProfilesActions.loadPlaceDetailsFailure({ error }))),
        ),
      ),
    ),
  );

  loadSpotlightProfiles$ = createEffect(() =>
    this._actions$.pipe(
      ofType(
        SpotlightProfilesActions.loadSpotlightProfiles,
        SpotlightProfilesActions.loadPlaceDetailsSuccess,
      ),
      switchMap(({ directoryId, filters }) =>
        this._spotlightProfileApi.loadSpotlightProfiles(directoryId, filters).pipe(
          map((spotlightProfilesPageData) =>
            SpotlightProfilesActions.loadSpotlightProfilesSuccess({
              meta: spotlightProfilesPageData.meta,
              profiles: spotlightProfilesPageData.profiles,
            }),
          ),
          catchError((error) =>
            of(SpotlightProfilesActions.loadSpotlightProfilesFailure({ error })),
          ),
        ),
      ),
    ),
  );
}
